export const routesColor = [
  "#D11919",
  "#19D16F",
  "#1947D1",
  "#D18A19",
  "#8A19D1",
  "#19C7D1",
  "#D1198A",
  "#9AD119",
  "#D14F19",
  "#195FD1",
  "#B319D1",
  "#19D19A",
  "#D1C119",
  "#D11947",
  "#4719D1",
  "#19D147",
  "#D16A19",
  "#2B19D1",
  "#D119B3",
  "#63D119",

  "#B22222",
  "#22B25F",
  "#224CB2",
  "#B27622",
  "#7622B2",
  "#22AEB2",
  "#B22276",
  "#8EB222",
  "#B24A22",
  "#225FB2",
  "#9922B2",
  "#22B28E",
  "#B2A122",
  "#B2224A",
  "#4A22B2",
  "#22B24A",
  "#B26122",
  "#2F22B2",
  "#B22299",
  "#5FB222",

  "#C11717",
  "#17C16B",
  "#173FC1",
  "#C17C17",
  "#7C17C1",
  "#17B6C1",
  "#C1177C",
  "#97C117",
  "#C14F17",
  "#1757C1",
  "#A717C1",
  "#17C197",
  "#C1AF17",
  "#C1173F",
  "#3F17C1",
  "#17C13F",
  "#C16417",
  "#2717C1",
  "#C117A7",
  "#57C117",

  "#A31515",
  "#15A35A",
  "#1539A3",
  "#A36C15",
  "#6C15A3",
  "#15A3A3",
  "#A3156C",
  "#7CA315",
  "#A34715",
  "#154FA3",
  "#8F15A3",
  "#15A37C",
  "#A39415",
  "#A31539",
  "#3915A3",
  "#15A339",
  "#A35715",
  "#2315A3",
  "#A3158F",
  "#4FA315",

  "#CC2A2A",
  "#2ACC6E",
  "#2A52CC",
  "#CC842A",
  "#842ACC",
  "#2ABFCC",
  "#CC2A84",
  "#A3CC2A",
  "#CC5A2A",
  "#2A6ACC",
  "#B82ACC",
  "#2ACCA3",
  "#CCB82A",
  "#CC2A52",
  "#522ACC",
  "#2ACC52",
  "#CC6A2A",
  "#322ACC",
  "#CC2AB8",
  "#6ECC2A",

  "#961818",
  "#18964F",
  "#184496",
  "#966618",
  "#661896",
  "#189696",
  "#961866",
  "#6E9618",
  "#964418",
  "#185996",
  "#7F1896",
  "#18967F",
  "#968C18",
  "#961844",
  "#441896",
  "#189644",
  "#965918",
  "#2A1896",
  "#96187F",
  "#4F9618",

  "#D63030",
  "#30D67A",
  "#305CD6",
  "#D69130",
  "#9130D6",
  "#30CAD6",
  "#D63091",
  "#ADD630",
  "#D66B30",
  "#3075D6",
  "#C230D6",
  "#30D6AD",
  "#D6C230",
  "#D6305C",
  "#5C30D6",
  "#30D65C",
  "#D67530",
  "#3830D6",
  "#D630C2",
  "#7AD630",

  "#8F1010",
  "#108F48",
  "#103A8F",
  "#8F5C10",
  "#5C108F",
  "#10878F",
  "#8F105C",
  "#668F10",
  "#8F3A10",
  "#104E8F",
  "#75108F",
  "#108F66",
  "#8F8210",
  "#8F103A",
  "#3A108F",
  "#108F3A",
  "#8F4E10",
  "#20108F",
  "#8F1075",
  "#488F10",

  "#E03A3A",
  "#3AE087",
  "#3A6BE0",
  "#E09C3A",
  "#9C3AE0",
  "#3AD6E0",
  "#E03A9C",
  "#BCE03A",
  "#E0783A",
  "#3A82E0",
  "#CC3AE0",
  "#3AE0BC",
  "#E0CC3A",
  "#E03A6B",
  "#6B3AE0",
  "#3AE06B",
  "#E0823A",
  "#423AE0",
  "#E03ACC",
  "#87E03A",

  "#AD2020",
  "#20AD5E",
  "#2048AD",
  "#AD7320",
  "#7320AD",
  "#20A0AD",
  "#AD2073",
  "#7BAD20",
  "#AD4820",
  "#2061AD",
  "#9620AD",
  "#20AD7B",
  "#AD9620",
  "#AD2048",
  "#4820AD",
  "#20AD48",
  "#AD6120",
  "#2820AD",
  "#AD2096",
  "#5EAD20",
  "#CA3716",
  "#253CF4",
  "#5DD50B",
  "#B81486",
  "#C28F0A",
  "#7723E7",
  "#0AC223",

  "#145DB8",
  "#99CB0B",
  "#BC0AC2",
  "#16CA90",
  "#C2510A",
  "#3925F4",
  "#35B814",
  "#D50B6E",
  "#0A9AC2",
  "#CABD16",
  "#8C0BD5",
  "#0BD551",
  "#0D44F2",
  "#6CC20A",

  "#0AC2AD",
  "#D5830B",
  "#642CE8",
  "#0BD50D",

  "#167DCA",
  "#A9C20A",
  "#B50BD5",
  "#14B86E",
  "#D5400B",
  "#252CF4",
  "#51CA16",
  "#C20A7B",
  "#0BC3D5",
  "#B89714",
  "#7C0CE9",
  "#0AC232",
  "#0B52CB",
  "#90D50B",
  "#B814B0",
  "#0BD5A4",
  "#C2600A",
  "#5030E8",
  "#20C20A",
  "#D50B5E",
  "#1487B8",
  "#C1C20A",
  "#950BCB",
  "#16CA62",

  "#2042F3",
  "#5EB814",
  "#0AC2BB",
  "#CA8F16",
  "#6A16F3",
  "#0BD51D",
  "#B81436",
  "#0B6FD5",
  "#9BC20A",
  "#BC16CA",
  "#0AC27E",
  "#D54F0B",
  "#3930E8",
  "#3DD50B",
  "#C20A6D",
  "#16ABCA",
  "#C2AC0A",
  "#880CDF",
  "#14B845",
  "#D50C0B",
  "#0C49DF",
  "#7FCA16",
  "#C20AAA",
  "#0BD5B4",
  "#B86D14",
  "#5925F4",
  "#11C20A",
  "#CA1652",
  "#0A7DC2",
  "#BBCB0B",
  "#9614B8",
  "#0BD571",
  "#C2310A",
  "#303FE8",
  "#4FC20A",
  "#D50B92",
  "#14B1B8",
  "#D5A30B",
  "#760DF2",
  "#16CA35",
  "#C20A21",
  "#0B5FD5",
  "#88B814",
  "#0BD3D5",
  "#CA3716",
  "#253CF4",
  "#5DD50B",
  "#B81486",
  "#C28F0A",
  "#7723E7",
  "#0AC223",
  "#D50B2A",
  "#145DB8",
  "#99CB0B",
  "#BC0AC2",
  "#16CA90",
  "#C2510A",
  "#3925F4",
  "#35B814",
  "#D50B6E",
  "#0A9AC2",
  "#CABD16",
  "#8C0BD5"
];
